import { useCallback, useEffect, useState } from "react";
import { fetchMaintenanceConfig } from "services/maintenance/maintenanceConfig";
import {
  activateMaintenanceBypassFromUrl,
  isMaintenanceBypassActive,
  shouldShowMaintenancePage,
  syncMaintenanceBypassWithConfig,
} from "services/maintenance/maintenanceBypass";

const MAINTENANCE_POLL_INTERVAL_MS = 60_000;

export function useMaintenanceMode() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const checkMaintenanceMode = useCallback(async () => {
    activateMaintenanceBypassFromUrl();
    const config = await fetchMaintenanceConfig();
    syncMaintenanceBypassWithConfig(config.enabled);
    const showMaintenancePage = shouldShowMaintenancePage(config.enabled);
    setIsMaintenanceMode(showMaintenancePage);
    setIsLoading(false);
    return showMaintenancePage;
  }, []);

  useEffect(() => {
    void checkMaintenanceMode();
  }, [checkMaintenanceMode]);

  useEffect(() => {
    if (!isMaintenanceMode && !isMaintenanceBypassActive()) {
      return;
    }

    const intervalId = globalThis.setInterval(() => {
      void checkMaintenanceMode();
    }, MAINTENANCE_POLL_INTERVAL_MS);

    return () => {
      globalThis.clearInterval(intervalId);
    };
  }, [checkMaintenanceMode, isMaintenanceMode]);

  return { isMaintenanceMode, isLoading };
}
